var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useRef } from 'react';
import useDebounceCallback from './useDebounceCallback';
/**
 * 单击和双击事件处理
 * @param singleTap - 单击事件
 * @param doubleTap - 双击事件
 * @return invokeTap
 */
export default function useContinuousTap(singleTap, doubleTap) {
    // 当前连续点击次数
    var continuousClick = useRef(0);
    var debounceTap = useDebounceCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        continuousClick.current = 0;
        singleTap.apply(void 0, __spreadArray([], __read(args), false));
    }, {
        wait: 300,
    });
    return function invokeTap() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        continuousClick.current += 1;
        debounceTap.apply(void 0, __spreadArray([], __read(args), false));
        // 双击
        if (continuousClick.current >= 2) {
            debounceTap.cancel();
            continuousClick.current = 0;
            doubleTap.apply(void 0, __spreadArray([], __read(args), false));
        }
    };
}
